import ReceiveItemsBoxListPanel from "./receiveItemsBoxListPanel.container";
export default ReceiveItemsBoxListPanel;
